import superagent from 'superagent'
import isNil from 'lodash/isNil'
// import { __API_URI__ } from '../utils/config'

export const markersSet = markers => ({
  type: 'MARKERS_SET',
  payload: markers
})

export const markerCreate = marker => ({
  type: 'MARKER_CREATE',
  payload: marker
})

export const markerUpdate = marker => ({
  type: 'MARKER_UPDATE',
  payload: marker
})

export const markerThreeDUpdate = marker => ({
  type: 'MARKER_THREED_UPDATE',
  payload: marker
})

export const markerDelete = id => {
  return {
    type: 'MARKER_DELETE',
    payload: id
  }
}

export const removeUpdatedFlag = (marker) => {
  return {
    type: 'MARKER_THREED_REMOVE_UPDATED_FLAG',
    payload: marker
  }
}

export const markerCreateRequest = markerObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI_2__}/Marker/Create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(markerObj))
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
          reject(err)
        } else {
          Countly.q.push([
            'add_event',
            {
              key: 'Add Marker',
              count: 1,
              segmentation: {
                'Marker Type Name': `${markerObj.markerType.name}`
              }
            }
          ])
          dispatch(markerCreate(res.body))
          resolve(res.body)
        }
      })
  })
}

// Rejects with the superagent error when the save fails, 401 included (WEB-7104).
export const markerUpdateRequest = markerObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI_2__}/marker/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(markerObj))
      .end((err, res) => {
        if (err) return reject(err)
        dispatch(markerUpdate(res.body))
        resolve(res.body)
      })
  })
}

// Rejects with the superagent error when the save fails, 401 included (WEB-7104).
export const markerThreeDUpdateRequest = markerObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI_2__}/marker/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(markerObj))
      .end((err, res) => {
        if (err) return reject(err)
        dispatch(markerThreeDUpdate(res.body))
        resolve(res.body)
      })
  })
}

export const markerFetchRequest = () => (dispatch, getState, token) => {
  const markers = getState()
  return !isNil(markers) && markers.length > 0 ? Promise.resolve(markers) :
    new Promise(resolve => {
      superagent
        .get(`${__API_URI_2__}/marker/get`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            if (err.status == 401) {
              return err.status
            }
          }
          if (res) {
            resolve(res.body)
            dispatch(markersSet(res.body))
          } else {
            resolve([])
            dispatch(markersSet([]))
          }
        })
    })
}

// Rejects with the superagent error when the delete fails (WEB-7103), and only then leaves the
// object in the store; it's removed once the server confirms.
export const markerDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI_2__}/marker/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) return reject(err)
        dispatch(markersSet(getState().markers.filter(marker => marker.id !== id)))
        resolve(res.body)
      })
  })
}
